// Saved and scheduled reports. The numbers match the API enums, which the API
// writes and reads as numbers (no string enum converter is configured). The one
// exception, the saved filters' training type, uses GlobalConstants.TRAINING_TYPE_*
// ("required", "optional", "all").

export const SAVED_REPORT_KIND_ADMIN = 1;
export const SAVED_REPORT_KIND_MY_TEAM = 2;

export const REPORT_LEVEL_PROGRAMS = 1;
export const REPORT_LEVEL_MILESTONES = 2;
export const REPORT_LEVEL_OBJECTS = 3;

// Weekly or monthly only (1 was Daily, no longer offered)
export const SCHEDULE_FREQUENCY_WEEKLY = 2;
export const SCHEDULE_FREQUENCY_MONTHLY = 3;

export const SCHEDULE_FREQUENCIES = [
  { id: SCHEDULE_FREQUENCY_WEEKLY, name: "schedule_weekly" },
  { id: SCHEDULE_FREQUENCY_MONTHLY, name: "schedule_monthly" },
];

export const REPORT_FILE_FORMAT_EXCEL = 1;
export const REPORT_FILE_FORMAT_PDF = 2;
export const REPORT_FILE_FORMAT_CSV = 3;

export const REPORT_FILE_FORMATS = [
  { id: REPORT_FILE_FORMAT_EXCEL, name: "excel" },
  { id: REPORT_FILE_FORMAT_PDF, name: "pdf" },
  { id: REPORT_FILE_FORMAT_CSV, name: "csv" },
];

export const REPORT_SEND_TRIGGER_SCHEDULED = 1;
export const REPORT_SEND_TRIGGER_SEND_NOW = 2;

export const REPORT_SEND_RESULT_SENT = 1;
export const REPORT_SEND_RESULT_FAILED = 2;
export const REPORT_SEND_RESULT_SKIPPED = 3;

export const REPORT_DELIVERY_ATTACHMENT = 1;
export const REPORT_DELIVERY_LINK = 2;

export const SAVED_REPORT_NAME_MAX_LENGTH = 100;

// Schedules run on quarter hours (ReportSchedule.TimeOfDay is a multiple of 15).
export const SCHEDULE_TIME_STEP_MINUTES = 15;

// Query parameter that opens a saved report on a report screen.
export const SAVED_REPORT_QUERY_PARAM = "saved";

// NotificationType.ScheduledReport on the API: the scheduled report email, which
// is always on (its switch in the notification list is disabled).
export const NOTIFICATION_TYPE_SCHEDULED_REPORT = 9;
